import { render, staticRenderFns } from "./LicenseRow.vue?vue&type=template&id=8ed82b12"
import script from "./LicenseRow.vue?vue&type=script&lang=js"
export * from "./LicenseRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports